import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 bg-neutral-50 border-t border-neutral-200" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-4 font-medium">
            Trusted by professionals
          </div>
          <h2 className="font-heading leading-[0.95] tracking-tight">
            <span className="block text-4xl md:text-6xl font-black">Clinicians choose us</span>
            <span className="block text-4xl md:text-6xl font-thin">for a reason.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-neutral-200">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.id}
              className="bg-white p-8 md:p-10 flex flex-col justify-between gap-8 min-h-[340px]"
              data-testid={`testimonial-${t.id}`}
            >
              <Quote className="w-6 h-6 text-black" strokeWidth={1.5} />
              <p className="font-heading text-lg md:text-xl font-light leading-snug text-black flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 object-cover grayscale"
                />
                <div>
                  <div className="font-heading text-sm font-black tracking-tight">{t.name}</div>
                  <div className="text-xs text-neutral-500 font-light">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
